<template>
  <div id="app">
    
    <!-- 缺少EventUID提示 -->
    <div v-if="showMissingEventTip" class="fixed inset-0 bg-white flex items-center justify-center z-50 p-6">
      <div class="max-w-md text-center">
        <div class="w-24 h-24 mx-auto mb-6 bg-blue-100 rounded-full flex items-center justify-center">
          <i class="ri-calendar-close-line text-4xl text-blue-500"></i>
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-4">未找到赛事信息</h2>
        <p class="text-gray-600 mb-8">当前未找到赛事信息，请联系管理员</p>
      </div>
    </div>
    
    <router-view v-slot="{ Component }">
      <transition name="page" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import wechat from './utils/wechat';

const router = useRouter();
const showNonWeChatTip = ref(false);
const showMissingEventTip = ref(false);

// 微信环境检测
const isWeChat = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return /micromessenger/.test(userAgent);
};

// 检查EventUID
const checkEvent = () => {
  // 从 URL 获取 EventUID
  const urlParams = new URLSearchParams(window.location.search);
  const urlEventUID = urlParams.get('EventUID');
  
  // 从本地存储获取 EventUID
  const storedEventUID = localStorage.getItem('EventUID');
  
  // 只有当 URL 和 localStorage 都没有 EventUID 时，才显示错误提示
  // 注意：这里不应该显示错误，而是让 home/page.vue 处理显示赛事列表
  // 所以这个检查可以简化或移除
  showMissingEventTip.value = false;
  
  // 如果 URL 中有 EventUID，保存到本地存储
  if (urlEventUID && urlEventUID !== 'null' && urlEventUID !== 'undefined') {
    localStorage.setItem('EventUID', urlEventUID);
  }
};

// 检查所有必要条件
const checkAllConditions = () => {
  // 非微信环境下，仅检查EventUID，不显示微信环境提示
  checkEvent();
};

onMounted(() => {
  checkAllConditions();
});

// 监听路由变化，检查条件并初始化JSSDK
router.afterEach((to) => {
  checkAllConditions();
  
  // 只有在微信环境中才初始化JSSDK
  if (isWeChat()) {
    const shareConfig = {
      title: '武术锦标赛',
      desc: '欢迎参加武术锦标赛',
      link: window.location.href.split('#')[0]
    };
    
    wechat.init(shareConfig);
  }
});
</script>

<style>
/* 全局样式 */

/* 页面切换动画 */
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>